import { jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import Tooltip from '../Tooltip/Tooltip.js';
import Badge from '../../Badge/Badge.js';
import { InfoState } from '../../types.js';

/**
 * Componente creato per attirare l'attenzione su una informazione e fornire un aiuto con un tooltip.
*/
function DrawAttention({ className = undefined, closeDelay = undefined, position = undefined, type = undefined, outline = undefined, icon = undefined, message = undefined, tooltipContent, }) {
    const showOnHover = !closeDelay;
    const [show, onMouseEnter, onMouseLeave] = Tooltip.useTooltipHoverWithDelay(closeDelay);
    const child = useMemo(() => {
        if (icon) {
            return icon;
        }
        return (jsx(Badge, { outline: outline, alarm: type === InfoState.alarm, info: type === InfoState.info, warning: type === InfoState.warning, success: type === InfoState.success, safe: type === InfoState.safe, children: message }));
    }, [icon, message, outline, type]);
    return (jsx(Tooltip, { className: className, show: showOnHover ? undefined : show, onMouseEnter: showOnHover ? undefined : onMouseEnter, onMouseLeave: showOnHover ? undefined : onMouseLeave, content: tooltipContent, position: position, type: type, children: child }));
}

export { DrawAttention as default };
